// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setAddToListModalIsOpen from "@insite/client-framework/Store/Components/AddToListModal/Handlers/SetAddToListModalIsOpen";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import addToWishList from "@insite/client-framework/Store/Data/WishLists/Handlers/AddToWishList";
import translate from "@insite/client-framework/Translate";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

/* Starter Custom Code - Start */
import PlusCircleFill from "@store/Library/Components/Toolkit/Icons/PlusCircle/PlusCircleFill";
import { linkGetActionLinkProps } from "@store/Themes/common/props/link";
import { useIsPunchOutSession } from "@toolkit/Framework/Store/Context/ContextHooks";
/* Starter Custom Code - End */

interface OwnProps {
    labelOverride?: string;
    extendedStyles?: ProductAddToListLinkStyles;
}

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasProductContext;

const mapStateToProps = (state: ApplicationState) => ({
    wishListSettings: getSettingsCollection(state).wishListSettings,
    // Store Custom Code
    configurationSelection: state.pages.productDetails.configurationSelection,
    configurationCompleted: state.pages.productDetails.configurationCompleted,
});

const mapDispatchToProps = {
    setAddToListModalIsOpen,
    addToWishList,
};

export interface ProductAddToListLinkStyles {
    link?: LinkPresentationProps;
}

export const productAddToListLinkStyles: ProductAddToListLinkStyles = {
    link: linkGetActionLinkProps(PlusCircleFill),
};

/**
 * @deprecated Use productAddToListLinkStyles instead.
 */
export const productAddToListLink = productAddToListLinkStyles;

const ProductAddToListLink: React.FC<Props> = ({
    productContext: { product, productInfo },
    wishListSettings,
    labelOverride,
    setAddToListModalIsOpen,
    addToWishList,
    extendedStyles,
    productContext, // Store Custom Code
    configurationSelection, // Store Custom Code
    configurationCompleted, // Store Custom Code
    ...otherProps
}) => {
    const toasterContext = React.useContext(ToasterContext);
    const [styles] = React.useState(() => mergeToNew(productAddToListLink, extendedStyles));
    const isPunchOutSession = useIsPunchOutSession(); // Starter Custom Code
    /* Store Custom Code - Start */
    if (!configurationCompleted && (!product.canAddToWishlist || isPunchOutSession)) {
        return null;
    }
    /* Store Custom Code - End */

    const addToListLinkClickHandler = () => {
        /* Store Custom Code - Start */
        const mergedProductInfos = [];
        if (productContext.product.configurationType !== "Standard") {
            mergedProductInfos.push(productInfo);
        }
        if (configurationCompleted && productContext.product.configurationType === "Standard") {
            const configuration = productContext.product.detail?.configuration;
            const mergedOptions =
                configuration && configuration.configSections
                    ? configuration.configSections.reduce((acc, section) => {
                          if (section.sectionOptions) {
                              section.sectionOptions.forEach(option => {
                                  if (
                                      configurationSelection &&
                                      configurationSelection[section.id] === option.id &&
                                      option &&
                                      !acc.includes(option)
                                  ) {
                                      const existingOption = acc.find(item => item.productId === option.productId);
                                      if (option.name === "Empty") {
                                          return;
                                      }
                                      if (existingOption) {
                                          existingOption.qtyOrdered += productInfo.qtyOrdered;
                                      } else if (option.productId && productInfo.qtyOrdered) {
                                          acc.push({
                                              productId: option.productId,
                                              qtyOrdered: productInfo.qtyOrdered,
                                              unitOfMeasure: productInfo.unitOfMeasure,
                                          });
                                      }
                                  }
                              });
                          }
                          return acc;
                      }, [] as any[])
                    : [];

            if (mergedOptions) {
                mergedProductInfos.push(...mergedOptions);
            }
        }
        if (!productInfo) {
            toasterContext.addToast({
                body: translate("Product cannot be added to wishlists."),
                messageType: "danger",
            });
        } else {
            if (!wishListSettings.allowMultipleWishLists) {
                addToWishList({
                    productInfos: mergedProductInfos,
                    onSuccess: () => {
                        toasterContext.addToast({ body: siteMessage("Lists_ProductAdded"), messageType: "success" });
                    },
                    onComplete(resultProps) {
                        if (resultProps.result?.wishList) {
                            // "this" is targeting the object being created, not the parent SFC
                            this.onSuccess?.(resultProps.result?.wishList);
                        } else if (resultProps.result?.errorMessage) {
                            toasterContext.addToast({ body: resultProps.result?.errorMessage, messageType: "danger" });
                        }
                    },
                });
                return;
            }

            setAddToListModalIsOpen({ modalIsOpen: true, productInfos: mergedProductInfos });
        }
        /* Store Custom Code - End */
    };

    return (
        <Link
            {...styles.link}
            onClick={addToListLinkClickHandler}
            disabled={productInfo.qtyOrdered <= 0}
            {...otherProps}
        >
            {labelOverride ?? translate("Add to List")}
        </Link>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withProductContext(ProductAddToListLink));
